import React, { Component, Fragment, createRef } from 'react';
import './index.css';

const borders = [
  'leftBorder',        // 0
  'rightBorder',       // 1
  'topBorder',         // 2
  'bottomBorder',      // 3
  'upprLeftCorner',    // 4  top-left
  'upprRightCorner',   // 5  top-right
  'lowerLeftCorner',   // 6  bottom-left
  'lowerRightCorner'   // 7  bottom-right
];

class ScalableBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      footerHeight: null,
      prePosition: {
        widthBorder: 0,
        heightBorder: 0,
        mouseX: 0,
        mouseY: 0
      },
      width: null,
      height: null,
      panelBorderColor: new Array(borders.length).fill(false)
    }
    this.boxRef = createRef()
  }

  changeShapeStart = (i, e) => {
    e.stopPropagation();
    let colorList = this.state.panelBorderColor
    colorList[i] = true;
    this.setState({ panelBorderColor: colorList });
    this.props.changeStart();
    const { clientX, clientY } = e;
    const { panelWidth, panelHeight } = this.props;
    let headerHeight = this.props.getHeaderHeight();
    let footerHeight = this.props.getFooterHeight();
    let prePosition = {
      panelWidth,
      panelHeight,
      mouseX: clientX,
      mouseY: clientY
    }
    this.setState({
      prePosition,
      headerHeight,
      footerHeight
    })
  }

  changeShapeEnd = (i, e) => {
    let colorList = this.state.panelBorderColor
    colorList[i] = false;
    this.setState({ panelBorderColor: colorList });
    e.stopPropagation();
    e.preventDefault();
    const { headerHeight, footerHeight, width, height } = this.state;
    this.props.changeSize(i, width, height, footerHeight, headerHeight);
    this.props.changeEnd();
  }

  changeShape = (i, e) => {
    e.stopPropagation();
    e.preventDefault();

    const { clientX, clientY } = e;
    if (clientX === 0 && clientY === 0) return;

    const { panelWidth, panelHeight, mouseX, mouseY } = this.state.prePosition;
    const deltaX = clientX - mouseX;
    const deltaY = clientY - mouseY;

    let newWidth = panelWidth;
    let newHeight = panelHeight;

    switch (i) {
      case 0: // left
        newWidth = this.judgeWidth(panelWidth - deltaX);
        break;
      case 1: // right
        newWidth = this.judgeWidth(panelWidth + deltaX);
        break;
      case 2: // top
        newHeight = this.judgeHeight(panelHeight - deltaY);
        break;
      case 3: // bottom
        newHeight = this.judgeHeight(panelHeight + deltaY);
        break;
      case 4: // top-left
        newWidth = this.judgeWidth(panelWidth - deltaX);
        newHeight = this.judgeHeight(panelHeight - deltaY);
        break;
      case 5: // top-right
        newWidth = this.judgeWidth(panelWidth + deltaX);
        newHeight = this.judgeHeight(panelHeight - deltaY);
        break;
      case 6: // bottom-left
        newWidth = this.judgeWidth(panelWidth - deltaX);
        newHeight = this.judgeHeight(panelHeight + deltaY);
        break;
      case 7: // bottom-right
        newWidth = this.judgeWidth(panelWidth + deltaX);
        newHeight = this.judgeHeight(panelHeight + deltaY);
        break;
      default:
        break;
    }

    let footerHeight = this.props.getFooterHeight ? this.props.getFooterHeight() : this.state.footerHeight;

    this.setState({
      width: newWidth,
      height: newHeight,
      footerHeight
    }, () => {
      this.props.changeSize(i, newWidth, newHeight, footerHeight, this.state.headerHeight, true)
    });
  }

  // Determine whether the width limit is exceeded
  judgeWidth(num) {
    const { minWidth, maxWidth } = this.props
    if (minWidth && num < minWidth) {
      num = minWidth;
    } else if (maxWidth && num > maxWidth) {
      num = maxWidth;
    }

    return num;
  }

  // Determine whether the height limit is exceeded
  judgeHeight(num) {
    const { minHeight, maxHeight } = this.props
    if (minHeight && num < minHeight) {
      num = minHeight;
    }
    else if (maxHeight && num > maxHeight) {
      num = maxHeight;
    }

    return num;
  }

  render() {
    const { panelBorderColor } = this.state;
    return (
      <Fragment>
        <div
          className="boxSide"
          ref={this.boxRef}
        >
          {
            borders.map((border, i) => (
              <div
                draggable="true"
                className={[border, panelBorderColor[i] ? "panel-border-color" : ""].join(' ')}
                key={i}
                onDragStart={(e) => this.changeShapeStart(i, e)}
                onDrag={(e) => this.changeShape(i, e)}
                onDragEnd={(e) => this.changeShapeEnd(i, e)}
              >
              </div>
            ))
          }
        </div>
      </Fragment>
    )
  }
}

export default ScalableBox;